import { render } from "./Roteiro.vue?vue&type=template&id=4d19f2e9"
import script from "./Roteiro.vue?vue&type=script&lang=js"
export * from "./Roteiro.vue?vue&type=script&lang=js"

import "./Roteiro.vue?vue&type=style&index=0&id=4d19f2e9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__